(function () {
  'use strict';
  if (window.__ccLpInit) return;
  window.__ccLpInit = true;

  // Self-check quiz: 3 questions, simple weighted scoring -> result
  function initQuiz(root) {
    if (!root || root.dataset.ccQuizInit === '1') return;
    root.dataset.ccQuizInit = '1';

    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-cc-quiz-q]'));
    var resultEl = root.querySelector('[data-cc-quiz-result]');
    var progress = root.querySelector('[data-cc-quiz-progress]');
    var counterEl = root.querySelector('[data-cc-quiz-counter]');
    var restartBtn = root.querySelector('[data-cc-quiz-restart]');

    if (!questions.length || !resultEl) return;

    var idx = 0;
    var score = 0;

    function show(i) {
      questions.forEach(function (q, qi) { q.style.display = qi === i ? '' : 'none'; });
      resultEl.classList.remove('is-active');
      if (counterEl) counterEl.textContent = 'Question ' + (i + 1) + ' of ' + questions.length;
      if (progress) {
        Array.prototype.slice.call(progress.children).forEach(function (dot, di) {
          dot.classList.toggle('is-active', di <= i);
        });
      }
    }

    function showResult() {
      questions.forEach(function (q) { q.style.display = 'none'; });
      resultEl.classList.add('is-active');
      if (counterEl) counterEl.textContent = 'Result';
      if (progress) {
        Array.prototype.slice.call(progress.children).forEach(function (dot) { dot.classList.add('is-active'); });
      }
    }

    function reset() {
      idx = 0;
      score = 0;
      show(0);
    }

    questions.forEach(function (q) {
      var opts = q.querySelectorAll('[data-cc-quiz-option]');
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          var weight = parseInt(opt.getAttribute('data-cc-weight') || '0', 10);
          score += weight;
          idx += 1;
          if (idx < questions.length) {
            show(idx);
          } else {
            showResult();
          }
        });
      });
    });

    if (restartBtn) restartBtn.addEventListener('click', reset);

    show(0);
  }

  // FAQ accordion
  function initFaq(root) {
    if (!root || root.dataset.ccFaqInit === '1') return;
    root.dataset.ccFaqInit = '1';
    var items = root.querySelectorAll('.cc-lp__faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.cc-lp__faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var icon = btn.querySelector('.icon');
        if (icon) icon.textContent = isOpen ? '−' : '+';
      });
    });
  }

  // Sticky bar — show after scrolling past the hero
  function initSticky(bar) {
    if (!bar || bar.dataset.ccStickyInit === '1') return;
    bar.dataset.ccStickyInit = '1';
    var hero = document.querySelector('.cc-lp__hero');
    function update() {
      if (!hero) { bar.classList.add('is-visible'); return; }
      var heroBottom = hero.getBoundingClientRect().bottom;
      bar.classList.toggle('is-visible', heroBottom < 0);
    }
    document.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // AJAX add-to-cart: intercept any form[action="/cart/add"] inside .cc-lp,
  // POST to /cart/add.js, then trigger the theme's side cart drawer.
  function doAjaxAdd(form) {
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    if (btn) btn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      if (window.$s && typeof window.$s.addToCartSuccess === 'function') {
        window.$s.addToCartSuccess();
      } else if (window.SideCart && typeof window.SideCart.updateSideCart === 'function') {
        window.SideCart.updateSideCart(true);
      } else {
        location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    })
    .catch(function (err) {
      var msg = (err && err.description) || 'Could not add to cart.';
      if (window.$s && typeof window.$s.addToCartFail === 'function') {
        window.$s.addToCartFail(msg);
      } else {
        alert(msg);
      }
    })
    .finally(function () {
      if (btn) btn.removeAttribute('disabled');
    });
  }

  function initAjaxAtc() {
    var handler = function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!form.closest('.cc-lp')) return;
      e.preventDefault();
      e.stopPropagation();
      doAjaxAdd(form);
    };

    // Capture phase fires before any bubble-phase handler can interfere.
    document.addEventListener('submit', handler, true);

    // Also attach directly to each form as a redundant safety net.
    document.querySelectorAll('.cc-lp form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.ccAtcInit === '1') return;
      form.dataset.ccAtcInit = '1';
      form.addEventListener('submit', handler);
    });
  }

  function init() {
    document.querySelectorAll('[data-cc-quiz]').forEach(initQuiz);
    document.querySelectorAll('[data-cc-faq]').forEach(initFaq);
    document.querySelectorAll('[data-cc-sticky]').forEach(initSticky);
    initAjaxAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
